{
  "v4.design.annuler": "Cancel",
  "v4.design.aucun": "none",
  "v4.design.catalogue": "the charter choice catalogue",
  "v4.design.charte.afficher_jetons": "Show the tokens",
  "v4.design.charte.aucune_effective": "No validated version: the project follows the inherited or default charter.",
  "v4.design.charte.effective": "Project effective version: version {{version}} ({{semver}})",
  "v4.design.charte.enregistrer": "Save a new version",
  "v4.design.charte.entete": "Version {{version}} ({{semver}}) — {{statut}}",
  "v4.design.charte.historique": "Version history",
  "v4.design.charte.historique_vide": "No earlier version.",
  "v4.design.charte.jetons": "Version tokens",
  "v4.design.charte.libelle": "the charter",
  "v4.design.charte.ligne_historique": "Version {{version}} ({{semver}}), {{statut}}, by {{auteur}} on {{date}}",
  "v4.design.charte.masquer_jetons": "Hide the tokens",
  "v4.design.charte.non_brouillon": "Only a draft can be validated.",
  "v4.design.charte.nouvelle": "New version",
  "v4.design.charte.origine.organisation": "Charter inherited from the organisation.",
  "v4.design.charte.origine.project": "Project charter.",
  "v4.design.charte.relue": "I have reviewed version {{version}} of the charter (fingerprint {{empreinte}}).",
  "v4.design.charte.revenir": "Return to the inherited charter",
  "v4.design.charte.revenir_confirmer": "Confirm the return to the inherited charter",
  "v4.design.charte.revenir_echec": "Returning to the inherited charter failed.",
  "v4.design.charte.revenir_effets": "The active override ends: the project follows the organisation charter again. No organisation waiver is lifted.",
  "v4.design.charte.revenir_sans_surcharge": "No active override: the project already follows the inherited charter.",
  "v4.design.charte.revenue": "The project follows the inherited charter again.",
  "v4.design.charte.statut.draft": "draft",
  "v4.design.charte.statut.superseded": "superseded",
  "v4.design.charte.statut.validated": "validated",
  "v4.design.charte.surcharge": "Request an override",
  "v4.design.charte.titre": "Product charter",
  "v4.design.charte.validation": "Validation by another person",
  "v4.design.charte.validation_echec": "The charter was not validated.",
  "v4.design.charte.validee": "Charter validated.",
  "v4.design.charte.validee_par": "— validated by {{nom}} on {{date}}",
  "v4.design.charte.valider": "Validate the charter",
  "v4.design.charte.vide": "No charter version.",
  "v4.design.choix.angles": "Corners",
  "v4.design.choix.couleur": "Primary colour",
  "v4.design.choix.densite": "Density",
  "v4.design.choix.fond": "Page background",
  "v4.design.choix.logo": "Logo (text)",
  "v4.design.choix.logo_style": "Logo style",
  "v4.design.choix.palette": "Palette {{nom}}",
  "v4.design.choix.ton": "Tone (typography)",
  "v4.design.choix.voix": "Labels voice",
  "v4.design.code.CREATEUR_N_APPROUVE_PAS": "Whoever created the version does not validate it: another project member validates it.",
  "v4.design.code.DESIGN_CHARTER_NOT_DRAFT": "Only a draft can be validated: this version already is or was superseded.",
  "v4.design.code.DESIGN_CHARTER_NOT_FOUND": "This charter version cannot be found in this project.",
  "v4.design.code.DESIGN_CHARTER_OUTDATED": "The charter changed since you read it: reload the page, review the new version, then validate it.",
  "v4.design.code.DESIGN_COMPARISON_NOT_FOUND": "This comparison cannot be found in this project.",
  "v4.design.code.DESIGN_CONTRAST_INSUFFICIENT": "Insufficient contrast: choose a darker primary colour or a lighter background.",
  "v4.design.code.DESIGN_FLOW_NOT_FOUND": "This flow cannot be found in this project.",
  "v4.design.code.DESIGN_FLOW_VERSION_CONFLICT": "The flow or wireframe changed since you read it: reload the page and review before validating.",
  "v4.design.code.DESIGN_NOT_DRAFT": "Only a draft can be validated.",
  "v4.design.code.DESIGN_OVERRIDE_REQUIRED": "The organisation charter applies: request a justified override first.",
  "v4.design.code.DESIGN_SELF_VALIDATION_REFUSED": "The author does not validate their own version: another project member validates it.",
  "v4.design.code.DESIGN_USABILITY_DATE_FUTURE": "A session cannot be recorded before it has taken place.",
  "v4.design.code.DESIGN_USABILITY_FINAL": "This test is already final.",
  "v4.design.code.DESIGN_WIREFRAME_NOT_FOUND": "This wireframe cannot be found in this project.",
  "v4.design.code.WORKSPACE_ARCHIVED": "The project is archived: it is read-only.",
  "v4.design.comparaison.afficher_maquette": "Show the {{nom}} wireframe",
  "v4.design.comparaison.apercus": "View the revision previews",
  "v4.design.comparaison.aucun_ecart": "No gap found.",
  "v4.design.comparaison.avis.aligned": "Matches the wireframe",
  "v4.design.comparaison.avis.major_gaps": "Major gaps",
  "v4.design.comparaison.avis.minor_gaps": "Minor gaps",
  "v4.design.comparaison.avis.nothing_compared": "Nothing compared",
  "v4.design.comparaison.avis.partial": "Partial comparison: some screens were not measured",
  "v4.design.comparaison.compteurs": "Expected screens: {{attendus}}; compared: {{compares}}; missing: {{absents}}. Major gaps: {{majeurs}}; minor: {{mineurs}}; informational: {{infos}}.",
  "v4.design.comparaison.cote_maquette": "{{nom}} wireframe",
  "v4.design.comparaison.cote_realisation": "{{nom}} implementation",
  "v4.design.comparaison.ecarts": "Gaps per screen",
  "v4.design.comparaison.ecran": "{{nom}} ({{route}}): {{n}} gap(s)",
  "v4.design.comparaison.entete": "Revision {{revision}} compared with flow version {{version}}",
  "v4.design.comparaison.libelle": "the comparison",
  "v4.design.comparaison.nature.autre": "Other gap",
  "v4.design.comparaison.nature.connexion_requise": "Sign-in required, screen not measured",
  "v4.design.comparaison.nature.couleur_hors_charte": "Colour outside the charter",
  "v4.design.comparaison.nature.ecran_manquant": "Missing screen",
  "v4.design.comparaison.nature.element_manquant": "Missing element",
  "v4.design.comparaison.nature.element_supplementaire": "Extra element",
  "v4.design.comparaison.nature.maquette_illisible": "Unreadable wireframe",
  "v4.design.comparaison.nature.maquette_manquante": "Missing wireframe",
  "v4.design.comparaison.nature.nombre_champs_different": "Different number of fields",
  "v4.design.comparaison.nature.titre_different": "Different title",
  "v4.design.comparaison.realisation": "Implementation: {{route}} of revision {{revision}}, captures {{largeurs}} px",
  "v4.design.comparaison.rien_a_montrer": "{{nom}}: neither validated wireframe nor implemented screen to show.",
  "v4.design.comparaison.sans_maquette": "No validated wireframe for this screen.",
  "v4.design.comparaison.sans_realisation": "The screen does not respond in the implementation.",
  "v4.design.comparaison.titre": "Comparison with the wireframe",
  "v4.design.comparaison.voir_parcours": "View the flow",
  "v4.design.comparaison.vues": "Side-by-side views",
  "v4.design.contraste.bloque": "Cannot save: {{n}} pair(s) below the contrast minimum.",
  "v4.design.contraste.conforme": "Contrast compliant on the {{n}} pairs checked (WCAG 2.2 AA).",
  "v4.design.contraste.juste": "Barely readable — {{paire}}: {{ratio}}.",
  "v4.design.contraste.non_calcule": "Contrast not computed: colour to complete.",
  "v4.design.contraste.paire": "{{paire}}: {{ratio}} (minimum {{minimum}})",
  "v4.design.derogation": "View the waiver",
  "v4.design.ecran_non_realise": "“{{ecran}}”: screen not built yet, served by another package of the wave.",
  "v4.design.et": "and",
  "v4.design.etat.chargement": "Loading {{quoi}}…",
  "v4.design.etat.en_cours": "In progress…",
  "v4.design.etat.erreur": "Could not read {{quoi}}.",
  "v4.design.etat.introuvable": "Not found: {{quoi}}.",
  "v4.design.etat.reessayer": "Retry",
  "v4.design.etat.refus": "Access denied: {{quoi}}.",
  "v4.design.heritage.defaut": "No project charter is required: without one, the project follows the default charter.",
  "v4.design.heritage.derogation_requise": "A project charter will only be validated with a waiver granted by the organisation.",
  "v4.design.heritage.impose": "Inherited organisation charter: version {{version}} ({{semver}}), enforced.",
  "v4.design.heritage.libelle": "the inherited charter",
  "v4.design.heritage.recommande": "Inherited organisation charter: version {{version}} ({{semver}}), recommended.",
  "v4.design.parcours.aucune_maquette": "No wireframe for this flow.",
  "v4.design.parcours.criteres_ecran": "Criteria served by screen {{n}} (comma separated)",
  "v4.design.parcours.document_source": "View the source document",
  "v4.design.parcours.edition": "New flow version",
  "v4.design.parcours.enregistre": "New flow version saved, to be validated.",
  "v4.design.parcours.enregistrement_echec": "The new version was not saved.",
  "v4.design.parcours.enregistrer": "Save a new version",
  "v4.design.parcours.entete": "Version {{version}} — {{etat}}, by {{auteur}}",
  "v4.design.parcours.etat.perime": "outdated",
  "v4.design.parcours.etat.propose": "proposed",
  "v4.design.parcours.etat.valide": "validated",
  "v4.design.parcours.etat_maquette.a_valider": "to validate",
  "v4.design.parcours.etat_maquette.perimee": "outdated",
  "v4.design.parcours.etat_maquette.validee": "validated",
  "v4.design.parcours.invalide": "Each screen needs a name and a path starting with “/”.",
  "v4.design.parcours.libelle": "the flow",
  "v4.design.parcours.maquette": "Wireframe {{ecran}} v{{version}} — {{etat}}",
  "v4.design.parcours.maquette_libelle": "the wireframe",
  "v4.design.parcours.maquette_relue": "I have reviewed wireframe {{ecran}} v{{version}} (fingerprint {{empreinte}}).",
  "v4.design.parcours.maquette_relue_sans": "I have reviewed the chosen wireframe.",
  "v4.design.parcours.maquette_validee": "Wireframe validated.",
  "v4.design.parcours.maquettes": "Wireframes",
  "v4.design.parcours.nom_ecran": "Screen {{n}} name",
  "v4.design.parcours.non_servis": "Unserved criteria: {{liste}}",
  "v4.design.parcours.reference": "Wireframe {{ecran}}, version {{version}}, fingerprint {{empreinte}}, by {{auteur}}",
  "v4.design.parcours.relu": "I have reviewed version {{version}} of the flow.",
  "v4.design.parcours.rendu": "Open the wireframe rendering",
  "v4.design.parcours.route_ecran": "Screen {{n}} path",
  "v4.design.parcours.sans_critere": "Screens without criterion: {{liste}}",
  "v4.design.parcours.sans_source": "Written by hand, without a source document.",
  "v4.design.parcours.selection_requise": "Choose a wireframe in the list.",
  "v4.design.parcours.source": "From decision no. {{id}}.",
  "v4.design.parcours.titre": "Flow and wireframes",
  "v4.design.parcours.validation": "Flow validation",
  "v4.design.parcours.validation_echec": "Validation failed.",
  "v4.design.parcours.valide_ok": "Flow validated.",
  "v4.design.parcours.valider": "Validate the flow",
  "v4.design.parcours.valider_maquette": "Validate the wireframe",
  "v4.design.preparer.cree": "Charter version saved as a draft.",
  "v4.design.preparer.creer": "Create the charter",
  "v4.design.preparer.distincte": "The first version belongs to the project, distinct from the inherited charter.",
  "v4.design.preparer.echec": "The charter version was not saved.",
  "v4.design.preparer.sans_validation": "Saved as a draft: another person validates it afterwards.",
  "v4.design.preparer.titre": "Prepare a first charter",
  "v4.design.retour": "Back to design",
  "v4.design.sans_projet": "Choose a project first.",
  "v4.design.usage.ajouter_observation": "Add an observation",
  "v4.design.usage.aucune_derogation": "No waiver for this test.",
  "v4.design.usage.besoin_date": "Enter the session date.",
  "v4.design.usage.besoin_definitif": "Confirm that the result is final.",
  "v4.design.usage.besoin_observation": "Write at least one observation.",
  "v4.design.usage.besoin_participants": "Enter the number of actual participants.",
  "v4.design.usage.besoin_reussites": "For each task, enter how many participants succeeded (0 to {{max}}).",
  "v4.design.usage.besoin_verdict": "Choose the verdict.",
  "v4.design.usage.choisir": "Choose…",
  "v4.design.usage.conclusion": "Conclusion",
  "v4.design.usage.critere": "Usability criterion: {{ref}} {{libelle}}; success: {{reussite}}",
  "v4.design.usage.date": "Session date",
  "v4.design.usage.date_future": "A session cannot be recorded before it has taken place.",
  "v4.design.usage.definitif": "The result is final: it can no longer be changed.",
  "v4.design.usage.definitif_lecture": "Final result: it can no longer be changed.",
  "v4.design.usage.derogation_indisponible": "Request a waiver: unavailable until the organisation circuit is decided.",
  "v4.design.usage.derogee": "Test waived: {{motif}}",
  "v4.design.usage.echec": "The result was not saved.",
  "v4.design.usage.enregistre": "Result saved.",
  "v4.design.usage.enregistrer": "Save the result",
  "v4.design.usage.entete": "{{titre}} — {{etat}}",
  "v4.design.usage.etat.a_realiser": "to run",
  "v4.design.usage.etat.deroge": "waived",
  "v4.design.usage.etat.realise": "run",
  "v4.design.usage.gravite": "Severity {{n}}",
  "v4.design.usage.gravites.blocking": "Blocking",
  "v4.design.usage.gravites.info": "Information",
  "v4.design.usage.gravites.major": "Major",
  "v4.design.usage.gravites.minor": "Minor",
  "v4.design.usage.introuvable": "This usability test cannot be found in this project.",
  "v4.design.usage.libelle": "the usability test",
  "v4.design.usage.observation": "Observation {{n}}",
  "v4.design.usage.observation_vide": "Fill in the current observation before adding another one.",
  "v4.design.usage.participants": "{{n}} planned participants ({{profil}})",
  "v4.design.usage.presents": "Actual participants",
  "v4.design.usage.resultat": "Session result",
  "v4.design.usage.reussie_par": "{{tache}}: succeeded by (out of {{max}})",
  "v4.design.usage.sans_critere": "not specified",
  "v4.design.usage.titre": "Usability test",
  "v4.design.usage.verdict": "Verdict",
  "v4.design.usage.verdict_lecture": "Verdict: {{verdict}} (session of {{date}}, {{n}} participants).",
  "v4.design.usage.verdicts.failed": "Failed",
  "v4.design.usage.verdicts.partial": "Partial",
  "v4.design.usage.verdicts.passed": "Passed"
}
